import React, { FC, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Modal from '~ComponentsImproved/Modal';
import { GetPendingOrders_venue_orders } from '~Queries/__queries__';
import useI18n from '~Translations';
import IncomingOrder from '../IncomingOrder';
import Heading from '~ComponentsImproved/Typography/Heading';
import Loader from '~ComponentsImproved/Loader';
import { useIncomingAppOrders } from '~Providers/IncomingAppOrdersProvider';

const Content = styled.div`
  background-color: var(--colorBlueGray1300);
  border-radius: 8px;
  overflow: auto;
  width: 100%;
  height: 100%;
  max-width: 740px;
  font-weight: 600;
`;

const InnerContent = styled.div`
  padding: 48px;
`;

interface Props {
  hide: () => void;
}

const IncomingOrdersModal: FC<Props> = ({ hide }) => {
  const { i18n } = useI18n();
  const incomingAppOrders = useIncomingAppOrders();

  return (
    <>
      <Modal isShowing={true} hide={hide}>
        <Content>
          <InnerContent>
            <Heading level={1} color="#fff" bottom={32}>
              {i18n('KDS.IncomingOrders')}
            </Heading>
            {incomingAppOrders.orderFetchingLoading ? (
              <Loader />
            ) : (
              <div>
                {incomingAppOrders.ordersToHandle.map((order) => {
                  return <IncomingOrder order={order} key={order.id} />;
                })}
              </div>
            )}
          </InnerContent>
        </Content>
      </Modal>
    </>
  );
};

export default IncomingOrdersModal;
